import socialIcons from "@/components/social-icons/social-icons.vue";
import newsletterForm from "@/components/newsletter-form/newsletter-form.vue";
import confirmationPageMixin from "@/pages/confirmation/mixin";

export default {
  mixins: [confirmationPageMixin],
  components: {
    socialIcons,
    newsletterForm,
  },
};
